const TestNoteType = Object.freeze({
    PRACTITIONER: 0,
    SYSTEM: 1,
    ISSUE: 2
})

export default TestNoteType